import * as yup from 'yup';

export const schema = yup
  .object({
    num_serie: yup.string().required('Número de série é obrigatório'),
    num_ult_nf_emitida: yup.number().min(0).notRequired(),
    cod_especie: yup.object().shape({
      label: yup.string().required(),
      value: yup.number().required(),
    }),
  })
  .required();
